import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Button from '../Button';
import SvgIconUse from '@SvgIconUse';
import LocalizedText from '@LocalizedText';

import './LabeledIconButton.scss';

const LabeledIconButton = ({ className, onClick, iconId, locKey, hidden = false, disabled = false, ...props }) => {
  return (
    <Button
      onClick={onClick}
      className={classnames('qau-labeled-icon-btn', className, { hidden, disabled })}
      {...props}
    >
      <SvgIconUse id={iconId} data-testid="svg-icon" />
      {locKey && <LocalizedText id={locKey} />}
    </Button>
  );
};

LabeledIconButton.propTypes = {
  iconId: PropTypes.string,
  locKey: PropTypes.string,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default LabeledIconButton;
